import { render, staticRenderFns } from "./ProductTierIndividualItem.vue?vue&type=template&id=05a236ec&scoped=true&lang=pug&"
import script from "./ProductTierIndividualItem.vue?vue&type=script&lang=js&"
export * from "./ProductTierIndividualItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductTierIndividualItem.vue?vue&type=style&index=0&id=05a236ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a236ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VForm,VSpacer})
